<template>
    <div ref="joint"></div>
</template>

<script>
import { dia, shapes } from '@joint/core';

export default {
    name: 'JointPaper',
    emits: ['init'],
    props: {
        width: {
            type: String,
            default: '3000px',
        },
        height: {
            type: String,
            default: '3000px',
        },
        gridSize: {
            type: Number,
            default: 1,
        },
        drawGrid: {
            type: [Object, Boolean],
            default: false,
        },
        background: {
            type: [Object, Boolean],
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        defaultLink: {
            type: Function,
            default: () => new shapes.standard.Link(),
        },
        linkPinning: {
            type: Boolean,
            default: false,
        },
        validateConnection: {
            type: Function,
            default: () => true,
        },
    },
    created() {
        this.graph = new dia.Graph({}, { cellNamespace: shapes });
    },
    mounted() {
        this.paper = new dia.Paper({
            el: this.$refs.joint,
            cellViewNamespace: shapes,
            model: this.graph,
            width: this.width,
            height: this.height,
            gridSize: this.gridSize,
            drawGrid: this.drawGrid,
            background: this.background,
            interactive: !this.readonly,
            defaultLink: this.defaultLink,
            linkPinning: this.linkPinning,
            validateConnection: this.validateConnection,
        });
        this.$emit('init', this.graph, this.paper);
    },
};
</script>
